/* eslint-disable react/no-danger */
import React, { FC, useMemo, useState, useCallback, useRef, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import properties from '../../../modules/ajio-util/properties';
// import properties from '../modules/ajio-util/properties';

const RatedAll = () => {
  const IMAGE_PATH = `${properties.getProperty('imageBaseUrl')}/static/img`;
  const icon = `${IMAGE_PATH}/rated-all.svg`;
  const cx = classNames.bind(styles);
  return (
    <>
      <div className={cx('rated-all')}>
        <div className={cx('left-rated-all')} style={{}}>
          <img
            src={icon}
            loading="eager"
            className={cx('rated-all-card-image')}
            alt="Tick icon"
          />
        </div>
        <div className={cx('right-rated-all')}>
          <p className={cx('rated-all-text')}>You have rated all your purchases</p>
          <p className={cx('thank-text')}>Thank you for taking out the time</p>
        </div>
      </div>
    </>
  );
};

RatedAll.defaultProps = {};

export default RatedAll;
